import { render, staticRenderFns } from "./Forecasting.vue?vue&type=template&id=b6cd7a32"
import script from "./Forecasting.vue?vue&type=script&lang=js"
export * from "./Forecasting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports